import { FC, PropsWithChildren, ReactNode } from 'react';

import { useFeatureFlag } from '@/providers/FeatureFlagsProvider/hooks/useFeatureFlag';
import { Flags } from '@/providers/FeatureFlagsProvider/type';

type FeatureFlagProps = {
  name: keyof Flags;
  override?: ReactNode;
} & PropsWithChildren;

/**
 * FeatureFlag component
 * @param name - feature flag name
 * @param [override] - override component if feature flag is false
 * @param children - component to render if feature flag is true
 * @constructor
 * @export
 * <FeatureFlag name='newHeader' override={<OldHeader />}>
 *   <NewHeader />
 * </FeatureFlag>
 */
export const FeatureFlag: FC<FeatureFlagProps> = ({
  name,
  override = null,
  children,
}) => (useFeatureFlag(name) ? <>{children}</> : <>{override}</>);
